// Fetch list

export const FETCH = 'vehicleTypes.FETCH'
export const FETCH_STARTED = 'vehicleTypes.FETCH_STARTED'
export const FETCH_FULFILLED = 'vehicleTypes.FETCH_FULFILLED'
export const FETCH_REJECTED = 'vehicleTypes.FETCH_REJECTED'
export const FETCH_CANCELLED = 'vehicleTypes.FETCH_CANCELLED'

export const SORTING_CHANGED = 'vehicleTypes.SORTING_CHANGED'

// Fetch one

export const FETCH_ONE = 'vehicleTypes.FETCH_ONE'
export const FETCH_ONE_STARTED = 'vehicleTypes.FETCH_ONE_STARTED'
export const FETCH_ONE_FULFILLED = 'vehicleTypes.FETCH_ONE_FULFILLED'
export const FETCH_ONE_REJECTED = 'vehicleTypes.FETCH_ONE_REJECTED'
export const FETCH_ONE_CANCELLED = 'vehicleTypes.FETCH_ONE_CANCELLED'

// Save

export const SAVE = 'vehicleTypes.SAVE'
export const SAVE_STARTED = 'vehicleTypes.SAVE_STARTED'
export const SAVE_FULFILLED = 'vehicleTypes.SAVE_FULFILLED'
export const SAVE_REJECTED = 'vehicleTypes.SAVE_REJECTED'
export const SAVE_CANCELLED = 'vehicleTypes.SAVE_CANCELLED'

// Delete

export const DELETE = 'vehicleTypes.DELETE'
export const DELETE_STARTED = 'vehicleTypes.DELETE_STARTED'
export const DELETE_FULFILLED = 'vehicleTypes.DELETE_FULFILLED'
export const DELETE_REJECTED = 'vehicleTypes.DELETE_REJECTED'
export const DELETE_CANCELLED = 'vehicleTypes.DELETE_CANCELLED'

// Export

export const EXPORT = 'vehicleTypes.EXPORT'
export const EXPORT_FULFILLED = 'vehicleTypes.EXPORT_FULFILLED'
